import { Loader } from '@bitstopco/bitstop-theme';
import { Card, CardContent, CardHeader, Divider, Grid } from '@mui/material';
import { skipToken } from '@reduxjs/toolkit/query/react';
import { useParams } from 'react-router';

import CassetteInventoryCard from '@/components/restocking/CassetteInventoryCard';

import { useGetMachineQuery } from '@/store/api/services/machines/machine';
import { useGetRestockRequestQuery } from '@/store/api/services/restocking/restocking';

export const OrderInventory = () => {
  const { id = '' } = useParams();

  const {
    data: { data: order = null } = {},
    isLoading: isLoadingOrder,
  } = useGetRestockRequestQuery(id);
  const {
    data: { data: machine = null } = {},
    isLoading: isLoadingMachine,
  } = useGetMachineQuery(order?.atm_id || skipToken);

  const isLoading = isLoadingMachine || isLoadingOrder;

  if (isLoading) return <Loader />;
  return (
    <Card>
      <CardHeader title="Current Inventory" />
      <Divider />
      <CardContent>
        <Grid container spacing={2}>
          {machine?.note_dispenser_cassettes?.map((cassette) => (
            <Grid key={cassette.id} item xs={12} md={6} lg={3}>
              <CassetteInventoryCard atm_id={machine?.id ?? 0} cassette={cassette} />
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};
